import { handleResponseOld, makePost } from './helpers';

/**
 * @category Mainhost API
 * @see postItemRemovalResponse
 */
type PostItemRemovalResponseParams = {
    authToken: string;
    deployment: string;
    lotId: string;
    response: string;
    timestamp: string;
    verificationCode: string;
};

/**
 * postItemRemovalResponse - updates user password
 * @category Mainhost API
 * @function postItemRemovalResponse
 * @param {PostItemRemovalResponseParams}
 * @see https://mainhost-DEPLOYMENT.liveauctioneers.com/api/eoa_removal_response
 * @see https://github.com/LIVEauctioneers/mainhost-prod/blob/master/libs/MOBILE_API.php#L720
 */
export const postItemRemovalResponse = ({
    authToken,
    deployment,
    lotId,
    response,
    timestamp,
    verificationCode,
}: PostItemRemovalResponseParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/eoa_removal_response`,
            queryParams: { client_version: '4.3' },
        });
        request.field('l', lotId || '');
        request.field('r', response || '');
        request.field('ts', timestamp || '');
        request.field('v', verificationCode || '');
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
